import { useState } from 'react';

const faqs = [
  {
    question: 'What types of digital asset service providers can benefit from Real-Time Proof of Reserves attestations?',
    answer: 'Multiple company types can benefit from real-time transparency reporting, especially those that issue tokens backed by real-world assets. Similarly, those issuing exchange-traded notes backed by on-chain assets can close the transparency gap between on- and off-chain assets with real-time attestation reporting services.',
    bullets: [
      'Stablecoins: where attestation reporting provides transparency to a token that is issued on a blockchain, pegged to a fiat currency, and the backing by assets held in reserve by the issuer\'s custodian on behalf of token holders.',
      'Asset-Backed Tokens: where attestation reporting provides transparency to a token issued on a blockchain that is pegged/representative of another type of asset or instrument, such as a carbon-credit, partnership interest in real estate, or an ounce of gold, and is backed by assets held in reserve by the issuer\'s custodian on behalf of token holders.',
      'Exchange Traded Products: where attestation reporting provides transparency to a security instrument issued and backed by digital assets held in reserve by the issuer\'s custodian on behalf of noteholders.',
    ],
  },
  {
    question: 'Can I pair Real-Time Reserves with your On-Chain Proof of Reserves Service?',
    answer: 'Yes! In fact, it is encouraged to provide real-time transparency to your "traditional" users expecting a CPA attestation, along with crypto-native users expecting an On-Chain Proof of Reserves!',
  },
  {
    question: 'How long does it take to complete the integration and begin reporting with Real-Time Reserves?',
    answer: 'The standard integration timeline is 6 weeks. Integration and reporting start times depend on technical scoping and the attest customer onboarding processes.',
  },
  {
    question: 'Is it really "real time"?',
    answer: 'It\'s more real-time than annual audits, and more real-time than monthly attestations. The technology we utilize for all Real-Time Proof of Reserves services has a 30-second heartbeat and will call APIs and other sources on that cadence.',
    bullets: [
      'The reporting interval (the time between the timestamp of the last attest report and the time a new attest report is available) depends on the least available data source.',
      'Assuming all of the token, bank or other balance information is readily available via API or similar data extraction method, we can reduce the reporting interval to 30 seconds, compared to every 30 days (+ time to issue) for traditional "static" stablecoin attestations!',
      'However, if a data source is restricted to providing balance data once an hour, then our reporting interval would be 1 hour (because we are bound by the least available data source).',
      'Most Real-Time Reserve services have a reporting interval between 30 seconds and daily.',
    ],
  },
  {
    question: 'Will Real-Time Reserves fulfill my reporting requirements?',
    answer: 'If your regulator accepts attestation reports under attestation standards promulgated by the AICPA our solution will almost certainly meet your requirements.',
    bullets: [
      'We encourage prospective customers to discuss potential attestation services with their regulators.',
      'We have and will produce additional information regarding our services for regulators\' review. Just inquire with us.',
    ],
  },
];

const Faq = () => {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-12 sm:mb-16 text-accent">
          Real-Time Reserves FAQ
        </h2>

        <div className="max-w-4xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border-2 border-gray-200 rounded-2xl overflow-hidden hover:border-accent transition-colors"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full px-6 sm:px-8 py-5 sm:py-6 text-left flex items-center justify-between bg-white hover:bg-gray-50 transition-colors"
              >
                <span className="text-base sm:text-lg font-semibold text-gray-900 pr-6 sm:pr-8">
                  {faq.question}
                </span>
                <svg
                  className={`w-6 h-6 text-accent flex-shrink-0 transition-transform ${openFaq === index ? 'transform rotate-180' : ''}`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {openFaq === index && (
                <div className="px-6 sm:px-8 py-6 bg-gray-50 border-t-2 border-gray-200">
                  <p className="text-gray-700 mb-4">{faq.answer}</p>
                  {faq.bullets && (
                    <div className="space-y-3 mt-4">
                      {faq.bullets.map((bullet, idx) => (
                        <div key={idx} className="flex items-start gap-3">
                          <div className="flex-shrink-0 w-5 h-5 rounded-full bg-accent flex items-center justify-center mt-0.5">
                            <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                            </svg>
                          </div>
                          <p className="text-gray-700 flex-1">{bullet}</p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
